import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { scenarioOneAPI } from 'api/scenarioOneAPI';
import produce from 'immer';

export const fetchScenarioOneStats = createAsyncThunk(
    'scenarioOneAPI/fetchScenarioOneStats',
    async (params) => await scenarioOneAPI.fetchStats(params)
);

export const fetchOutliersData = createAsyncThunk(
    'scenarioOneAPI/fetchOutliersData',
    async (params) => await scenarioOneAPI.fetchOutliersData(params)
);

export const fetchTrendData = createAsyncThunk(
    'scenarioOneAPI/fetchTrendData',
    async (params) => await scenarioOneAPI.fetchTrendData(params)
);

export const fetchPortfolioData = createAsyncThunk(
    'scenarioOneAPI/fetchPortfolioData',
    async (params) => await scenarioOneAPI.fetchPortfolioData(params)
);

const scenarioOneSlice = createSlice({
    name: 'scenarioOne',
    initialState: {
        clientSelected: null,
        selectedDataIndex: null,
        selectedSeriesIndex: null,
        stats: null,
        outlierData: null,
        outlierIsFetched: false,
        trendData: null,
        trendIsFetched: false,
        portfolioData: null,
        portfolioIsFetched: false
    },
    reducers: {
        updateClientSelected: (state, { payload }) =>
            produce(state, (draft) => {
                const { clientSelected, dataIndex, seriesIndex } = payload;
                draft.clientSelected = clientSelected;
                draft.selectedDataIndex = dataIndex;
                draft.selectedSeriesIndex = seriesIndex;
            }),
        resetScenarioOneCharts: (state) =>
            produce(state, (draft) => {
                draft.clientSelected = null;
                draft.selectedDataIndex = null;
                draft.selectedSeriesIndex = null;
            })
    },
    extraReducers: (builder) => {
        builder.addCase(fetchScenarioOneStats.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { statsReporting } = payload;
                draft.stats = statsReporting;
            })
        );
        builder.addCase(fetchOutliersData.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { outlierData } = payload;
                draft.outlierData = outlierData;
                draft.outlierIsFetched = true;
            })
        );
        builder.addCase(fetchTrendData.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { scenarioOneTrendAnalysisChartData } = payload;
                draft.trendData = scenarioOneTrendAnalysisChartData.data;
                draft.trendIsFetched = true;
            })
        );
        builder.addCase(fetchPortfolioData.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { portfolioData } = payload;
                draft.portfolioData = portfolioData.portfolios;
                draft.portfolioIsFetched = true;
            })
        );
    }
});

const { actions, reducer: scenarioOneReducer } = scenarioOneSlice;
export const { updateClientSelected, resetScenarioOneCharts } = actions;
export default scenarioOneReducer;
